import React, { useRef, useState } from "react";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { projects } from "../mock";

const Projects = () => {
  const scrollRef = useRef(null);
  const [showAll, setShowAll] = useState(false);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const amount = scrollRef.current.clientWidth * 0.8;
    scrollRef.current.scrollBy({ left: dir === "left" ? -amount : amount, behavior: "smooth" });
  };

  const visible = showAll ? projects : projects.slice(0, 4);

  return (
    <section id="projects" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F5B800] font-semibold tracking-widest text-sm uppercase">Our Projects</p>
          <h2 className="mt-2 text-3xl md:text-4xl font-extrabold text-[#0f2a5c] underline-yellow">
            Recent Work
          </h2>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll("left")}
            aria-label="Previous"
            className="scroll-btn hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 z-10 w-11 h-11 rounded-full bg-[#0f2a5c] text-white items-center justify-center shadow-lg hover:bg-[#0a1e42]"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          <div
            ref={scrollRef}
            className="no-scrollbar flex gap-6 overflow-x-auto md:overflow-visible md:grid md:grid-cols-4 scroll-smooth pb-3"
          >
            {visible.map((p) => (
              <div
                key={p.id}
                className="card-hover min-w-[260px] md:min-w-0 bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm"
              >
                <div className="h-40 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" />
                </div>
                <div className="p-4 text-center">
                  <h3 className="text-[#0f2a5c] font-bold">{p.title}</h3>
                  <p className="text-sm text-slate-500 mt-1">{p.subtitle}</p>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll("right")}
            aria-label="Next"
            className="scroll-btn hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 z-10 w-11 h-11 rounded-full bg-[#0f2a5c] text-white items-center justify-center shadow-lg hover:bg-[#0a1e42]"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 bg-[#0f2a5c] hover:bg-[#0a1e42] text-white font-semibold px-6 py-3 rounded-md shadow-md transition-colors"
          >
            {showAll ? "Show Less" : "View More Projects"} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
